'use client'

import { useParams, useRouter } from 'next/navigation'

import { useHandleLogin } from '@dfds-pax/auth'

interface Props {
  redirectPage: string
}

const HandleLogin: React.FC<Props> = ({ redirectPage }) => {
  const router = useRouter()
  const params = useParams()
  const { locale } = params as { locale: string }

  useHandleLogin({
    locale,
    onRedirect: (url: string) => router.replace(url),
    redirectPage,
  })

  return null
}

export default HandleLogin
